module.exports = require('./helpers/bundle-url').getBundleURL('43O8s') + "logo-dark.ba5147f0.svg";